// w18.js
import React from 'react';
import WW from './ww';
import { pageConfigs } from '../../configs';

const W18 = () => {
  return <WW config={pageConfigs.w18} />;
};

export default W18;
